export default __webpack_public_path__ + "static/media/back.eeb59b83.svg";